import React, { useEffect,useState } from "react";
import { useForm } from '@mantine/form';
import { Flex, Stack } from "@mantine/core";
import {BASEURL} from "../../../helpers/url_helper"
import { onupdateDrawing } from '../../../store/manageSite/actions';
import { useDispatch, useSelector } from "react-redux";
import { validateimageUrlFields, validateuploadFileFields } from "../../../helpers/common";
import MantineSelect from "../../../components/mantine/select";
import MantineFileInput from "../../../components/mantine/uploadfile";
import MantineButton from "../../../components/mantine/button";
import MantineTextInput from "../../../components/mantine/textinput";

const EditDrawingPopUp = (props: any) => {
    const { category, modalclose, dispatch, handleEdit, currentPrimaryColor, sitenameNames, categoryNames, clientId } = props;
    const [FileUrl, setFileUrl] = useState<string | null>(null);
    const { getsitename ,getcategory} = useSelector((state: any) => ({
        getsitename: state?.getsiteData?.sitelistdropdown,
        getcategory: state.getManualURL?.categorylist,
    }));

    const SelectedSite = getsitename?.find((site: any) => site.siteName === category?.siteName);
    
    const SelectedCategory = getcategory?.find((categorys: any) => categorys.name === category?.categoryName);
    const form = useForm({
        initialValues: {
            id: category?.id,
            sitename: SelectedSite?.siteId ? String(SelectedSite.siteId) : "",
            clientId: clientId,
            categoryId: SelectedCategory?.id ? String(SelectedCategory.id) : "",
            imageUrl: category?.imageUrl,
            uploadFile: null,
            Title: category?.title,
        },
        validate: {
            Title: (val) => (val ? null : 'Title is required'),
            imageUrl: (value, values) => validateimageUrlFields(value, values),
            uploadFile: (value, values) => validateuploadFileFields(value, values),
        },
    });

    useEffect(() => {       
        if (category?.uploadFile) {
            setFileUrl(category.uploadFile);
            form.setFieldValue('uploadFile', category.uploadFile);
        } else {
            setFileUrl(null);
            form.setFieldValue('uploadFile', null);
        }
    }, [category]);

    const handleCancel = (event: React.MouseEvent) => {
        event.preventDefault();
        modalclose();
    };
    const ChangeDrawing = () => {
        const data = {
            id: category?.id,
            siteId: form.values.sitename,
            clientId: form.values.clientId,
            categoryId: form.values.categoryId,
            imageUrl: form.values.imageUrl,
            uploadFile: form.values.uploadFile,
            title: form.values?.Title
        };       
        dispatch(onupdateDrawing(data, handleEdit));
    }; 
    const handleRemoveFile = () => {
        setFileUrl(null);
        form.setFieldValue('uploadFile', null);
    };
    const changeImageUrl = (url: any) => {
        if (url) {
            const urlObj = new URL(url);
            const fileName = urlObj.searchParams.get("fileName");
            return fileName || ''; 
        }
        return '';
    };   
    return (
        <form onSubmit={form.onSubmit(ChangeDrawing)}>
            <Stack>
                <MantineSelect
                    {...form.getInputProps('sitename')}
                    label="Select Site"
                    required
                    placeholder="Select From Dropdown"
                    data={sitenameNames}
                    classNames={{ input: 'w-[408px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full' }}
                />
                <MantineSelect
                    {...form.getInputProps('categoryId')}
                    label="Select Category"
                    required
                    placeholder="Select From Dropdown"
                    data={categoryNames}
                    classNames={{ input: 'w-[408px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full' }}
                />

                <MantineTextInput
                    {...form.getInputProps('Title')}
                    label={<span>Title <span style={{ color: 'red' }}>*</span></span>}
                    value={form.values.Title || ""}
                    placeholder="Enter the title"                    
                    classNames={{ input: 'w-[408px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full' }}
                    error={form.errors.Title}
                />                      
                <MantineTextInput
                    {...form.getInputProps('imageUrl')}
                    label={ <> Image Path <span style={{ color: 'red' }}>*</span> </> }
                    placeholder="Enter Your ImagePath"
                    value={form.values.imageUrl|| ""}
                    classNames={{ input: 'w-[408px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full' }}
                    error={form.errors.imageUrl}
                />   
                                
                <MantineFileInput
                    {...form.getInputProps('uploadFile')}
                    label={<>  File Upload <span style={{ color: 'red' }}>*</span> </> }
                    placeholder="Upload Your File"
                    color={currentPrimaryColor}
                    classNames={{ input: 'w-[363px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full pr-10' }}
                    error={form.errors.uploadFile}
                    fileUrl={changeImageUrl(FileUrl)}
                    onRemoveFile={handleRemoveFile} 
                />
                <Flex justify="flex-end">
                    <MantineButton name={'Save'} className={"mt-[15px] text-sm font-thin !w-[90px] mr-3"} type="submit" color={currentPrimaryColor} />
                    <MantineButton name={'Cancel'} className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px]"} onClick={handleCancel} />
                </Flex>
            </Stack>
        </form>
    );
};

export default EditDrawingPopUp;